import { Linking, View } from 'react-native';
import { setStringAsync } from 'expo-clipboard';
import { Divider } from 'react-native-elements';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { SubMenuItem as SubMenuItemType } from '@/components/ui/therapist/CollapsibleSidebar';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { useOnHover } from '@/hooks/useOnHover';

import { styles } from './styles';
import colors from '@/config/colors';
import { logError } from '@/utils/logHandling';
import { useState } from 'react';
import { ConfirmDialog } from '@/components/ui/shared/Dialog';

export const SubMenuItem = ({
  setExpandedSubMenu,
  subItem,
}: {
  setExpandedSubMenu: (submenu: SubMenuItemType[] | null) => void;
  subItem: SubMenuItemType;
}) => {
  const { icon, label, screen, url } = subItem;
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();
  const { navigate } =
    useNavigation<StackNavigationProp<TherapistStackParamList>>();
  const [showUrlModal, setShowUrlModal] = useState(false);

  const onMenuItemPress = async () => {
    if (!url) {
      navigate(screen as any);
      setExpandedSubMenu(null);
      return;
    }
    try {
      if (!(await Linking.canOpenURL(url))) {
        setShowUrlModal(true);
        logError(`Linking was unable to open URL`, null, {
          url,
        });
        return;
      }
      await Linking.openURL(url);
      setExpandedSubMenu(null);
    } catch (error) {
      setShowUrlModal(true);
      logError(`Encountered an error opening Linking URL`, error, {
        url,
      });
    }
  };

  return (
    <>
      <PressableNeolexon
        onPress={onMenuItemPress}
        onHoverIn={() => handleHoverIn()}
        onHoverOut={() => handleHoverOut()}
      >
        <View
          style={[
            styles.menuItemContainer,
            isHovered && styles.isSelected,
            { display: 'flex', justifyContent: 'space-between' },
          ]}
        >
          <Text style={styles.subMenuItem}>{label}</Text>
          {icon ? <Icon name={icon} size={15} /> : null}
        </View>
      </PressableNeolexon>
      <ConfirmDialog
        isVisible={showUrlModal}
        headerText={'Fehler beim Öffnen der Links'}
        confirmText={'In Zwischenablage kopieren'}
        cancelText={'Abbrechen'}
        confirmAction={async () => {
          await setStringAsync(url ?? '');
          setShowUrlModal(false);
        }}
        cancelAction={() => {
          setShowUrlModal(false);
        }}
      >
        <Text>
          Sie können die Adresse in die Zwischenablage kopieren und manuell in
          Ihrem Browser öffnen.
        </Text>
        <PressableNeolexon
          onPress={async () => await setStringAsync(url ?? '')}
        >
          <Text className="pt-4 font-bold">{url}</Text>
        </PressableNeolexon>
      </ConfirmDialog>
      <Divider color={colors.lightGrey} width={2} />
    </>
  );
};
